import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { createRequest } from "../utils/api";

export default function AddRequest({ token }) {
  const nav = useNavigate();

  const [title, setTitle] = useState("");
  const [budget, setBudget] = useState("");
  const [tags, setTags] = useState("");
  const [description, setDescription] = useState("");

  const [saving, setSaving] = useState(false);
  const [err, setErr] = useState("");

  async function submit(e) {
    e.preventDefault();
    setErr("");

    if (!token) {
      setErr("Please log in first.");
      return;
    }

    setSaving(true);
    try {
      const payload = {
        title,
        description,
        max_budget: budget ? Number(budget) : null,
      };

      await createRequest(token, payload);
      nav("/requests");
    } catch (e2) {
      setErr("Failed to create request.");
    } finally {
      setSaving(false);
    }
  }

  if (!token) {
    return (
      <div className="container pagePadBottom">
        <div className="card">
          <div style={{ fontWeight: 700 }}>Login required</div>
          <div className="muted small" style={{ marginTop: 6 }}>
            You need to log in to create a request.
          </div>
          <div style={{ marginTop: 12 }}>
            <Link className="btnPrimary" to="/login">
              Go to Login
            </Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="container pagePadBottom">
      <div className="pageHeader">
        <div className="pageHeaderLeft">
          <div className="h2">Create Request</div>
          <div className="muted small" style={{ marginTop: 6 }}>
            Describe what you need - sellers can respond.
          </div>
        </div>
        <div className="pageHeaderRight">
          <Link className="btnSecondary" to="/requests">
            Back
          </Link>
        </div>
      </div>

      {err ? (
        <div className="alert alertDanger">
          <div className="alertTitle">Error</div>
          <div className="alertBody">{err}</div>
        </div>
      ) : null}

      <form onSubmit={submit} className="card" style={{ marginTop: 14 }}>
        <div className="label">Title</div>
        <input
          className="input"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          placeholder="e.g. Wheelchair (lightweight)"
        />

        <div className="divider" />

        <div className="formRow">
          <div style={{ flex: 1, minWidth: 200 }}>
            <div className="label">Budget (optional)</div>
            <input
              className="input"
              value={budget}
              onChange={(e) => setBudget(e.target.value)}
              placeholder="e.g. 120"
            />
          </div>
          <div style={{ flex: 2, minWidth: 240 }}>
            <div className="label">Tags (comma separated)</div>
            <input
              className="input"
              value={tags}
              onChange={(e) => setTags(e.target.value)}
              placeholder="e.g. used, good condition, urgent"
            />
          </div>
        </div>

        <div className="divider" />

        <div className="label">Description</div>
        <textarea
          className="input"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          placeholder="Details, size, condition, timing…"
          rows={5}
          style={{ resize: "vertical" }}
        />

        <div className="divider" />

        <button className="btnPrimary" type="submit" disabled={saving}>
          {saving ? "Saving…" : "Post Request"}
        </button>
      </form>
    </div>
  );
}
